export default "__VITE_ASSET__DvACi3hH__"